var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineMessageSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.639 18.63-.91-1.21h-.25c-2.71 0-4.51-.77-4.51-4.51V9.77c0-2.68 1.37-4.27 3.86-4.48.19-.02.42-.03.65-.03h5.03c2.91 0 4.51 1.6 4.51 4.51v3.14c0 .24-.01.46-.04.68-.21 2.46-1.8 3.83-4.48 3.83h-.25l-.91 1.21c-.33.46-.82.72-1.34.72-.52 0-1.01-.26-1.36-.72zM8.989 6.78c-1.75.15-2.52 1.07-2.52 2.99v3.14c0 2.58.75 3.01 3.01 3.01h.31c.4 0 .85.22 1.1.54l.95 1.27c.06.08.12.12.15.12s.09-.04.15-.12l.94-1.26c.26-.35.67-.55 1.1-.55h.31c1.92 0 2.84-.77 2.99-2.49.02-.19.03-.35.03-.53V9.76c0-2.08-.93-3.01-3.01-3.01h-5.01c-.17 0-.34.01-.5.03z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v6c0 5.43-2.32 7.75-7.75 7.75H9zM2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25V9c0-4.61-1.64-6.25-6.25-6.25H9C4.39 2.75 2.75 4.39 2.75 9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineMessageSquare);
export default __webpack_public_path__ + "static/media/vuesax-outline-message-square.1c1081f27cff8133cd72646d87f57812.svg";
export { ForwardRef as ReactComponent };